module.exports = __webpack_public_path__ + "static/media/bandung.6044a461.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/bandung.mp3
// module id = 142
// module chunks = 0